import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Button} from '@gisatcz/ptr-atoms';

import './style.scss';
import ExpandableSection from '../../atoms/ExpandableSection';

const Division = ({
	className,
	active,
	children,
	onButtonClick,
	Title,
	ActiveButtonContent,
}) => {
	const classes = classnames(
		'insar-Division',
		{
			active,
		},
		className
	);

	return (
		<ExpandableSection
			minimiseDisallowed={active}
			className={classes}
			title={Title}
		>
			{active ? (
				<div className="insar-Division-content">{children}</div>
			) : (
				<Button className="insar-Division-map-button" onClick={onButtonClick}>
					<div>{ActiveButtonContent}</div>
				</Button>
			)}
		</ExpandableSection>
	);
};

Division.propTypes = {
	active: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node,
	onButtonClick: PropTypes.func,
	ActiveButtonContent: PropTypes.node,
	Title: PropTypes.node,
};

export default Division;
